// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-2vflq","return__massage":"return__massage-1HZaV","return__massage__icon":"return__massage__icon-1ZmFp"};